<template>
    <v-card class="pa-4">

        <v-tabs>

            <v-tab>Companies</v-tab>
            <v-tab>Users</v-tab>

            <!-- Companies Tab -->

            <v-tab-item v-if="loadingCompanies">
                <v-row class="py-10">
                    <v-col cols="12" class="d-flex justify-center align-center">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            size="60"
                            width="5">
                        </v-progress-circular>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item class="ma-4 mb-2" v-else-if="syncNeededCompanies">

                <v-row>
                    <v-col cols="12" md="6">
                        <h3 class="text-center">All Companies</h3>
                        <v-row class="my-2">
                            <v-col cols="12" md="4" align="center">
                                <p>Total ({{ companiesUtils.length }})</p>
                                <v-progress-circular
                                    color="blue-grey"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="100">
                                    <strong>100%</strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p>Ready ({{ companiesUtils.readyForPublishing }})</p>
                                <v-progress-circular
                                    color="blue-grey"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'readyForPublishing', 'length')">
                                    <strong>{{ getPercent('companiesUtils', 'readyForPublishing', 'length') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p class="blue--text font-weight-bold">Published ({{ companiesUtils.published }})</p>
                                <v-progress-circular
                                    color="blue"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'published', 'length')">
                                    <strong>{{ getPercent('companiesUtils', 'published', 'length') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-divider class="d-none d-md-block" vertical />

                    <v-col cols="12" md="6">
                        <h3 class="text-center">Risk (all published companies)</h3>
                        <v-row class="mt-2 mb-4">
                            <v-col cols="12" md="4" align="center">
                                <p>High ({{ companiesUtils.red }})</p>
                                <v-progress-circular
                                    color="#FF5252"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'red', 'published')">
                                    <strong>{{ getPercent('companiesUtils', 'red', 'published') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p>Medium ({{ companiesUtils.yellow }})</p>
                                <v-progress-circular
                                    color="#FFC107"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'yellow', 'published')">
                                    <strong :style="$vuetify.theme.dark ? '' : 'color: #000000de;'">
                                        {{ getPercent('companiesUtils', 'yellow', 'published') }}%
                                    </strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p>Low ({{ companiesUtils.green }})</p>
                                <v-progress-circular
                                    color="#1ac38d"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'green', 'published')">
                                    <strong>{{ getPercent('companiesUtils', 'green', 'published') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <v-divider class="my-6" />

                <v-row>
                    <v-col cols="12" md="6" align="center">
                        <h3 class="text-center pb-4">Public ({{ companiesUtils.publicLength }})</h3>
                        <v-progress-circular
                            color="blue-grey"
                            :width="progress.width"
                            :rotate="progress.rotate"
                            :size="progress.size"
                            :value="getPercent('companiesUtils', 'publicLength', 'published')">
                            <strong>{{ getPercent('companiesUtils', 'publicLength', 'published') }}%</strong>
                        </v-progress-circular>
                    </v-col>

                    <v-divider class="d-none d-md-block" vertical />

                    <v-col cols="12" md="6" align="center">
                        <h3 class="text-center pb-4">Private ({{ companiesUtils.privateLength }})</h3>
                        <v-progress-circular
                            color="blue-grey"
                            :width="progress.width"
                            :rotate="progress.rotate"
                            :size="progress.size"
                            :value="getPercent('companiesUtils', 'privateLength', 'published')">
                            <strong>{{ getPercent('companiesUtils', 'privateLength', 'published') }}%</strong>
                        </v-progress-circular>
                    </v-col>
                </v-row>

                <v-divider class="my-6" />

                <v-row>
                    <v-col cols="12" md="6">
                        <h3 class="text-center" v-if="!mdAndUp">Public ({{ companiesUtils.publicLength }})</h3>
                        <v-row class="mt-2 mb-4">
                            <v-col cols="12" md="4" align="center">
                                <p>High ({{ companiesUtils.publicRed }})</p>
                                <v-progress-circular
                                    color="#FF5252"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'publicRed', 'publicLength')">
                                    <strong>{{ getPercent('companiesUtils', 'publicRed', 'publicLength') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p>Medium ({{ companiesUtils.publicYellow }})</p>
                                <v-progress-circular
                                    color="#FFC107"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'publicYellow', 'publicLength')">
                                    <strong :style="$vuetify.theme.dark ? '' : 'color: #000000de;'">
                                        {{ getPercent('companiesUtils', 'publicYellow', 'publicLength') }}%
                                    </strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p>Low ({{ companiesUtils.publicGreen }})</p>
                                <v-progress-circular
                                    color="#1ac38d"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'publicGreen', 'publicLength')">
                                    <strong>{{ getPercent('companiesUtils', 'publicGreen', 'publicLength') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>

                    <v-divider class="d-none d-md-block" vertical />

                    <v-col cols="12" md="6">
                        <h3 class="text-center" v-if="!mdAndUp">Private ({{ companiesUtils.privateLength }})</h3>
                        <v-row class="mt-2 mb-4">
                            <v-col cols="12" md="4" align="center">
                                <p>High ({{ companiesUtils.privateRed }})</p>
                                <v-progress-circular
                                    color="#FF5252"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'privateRed', 'privateLength')">
                                    <strong>{{ getPercent('companiesUtils', 'privateRed', 'privateLength') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p>Medium ({{ companiesUtils.privateYellow }})</p>
                                <v-progress-circular
                                    color="#FFC107"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'privateYellow', 'privateLength')">
                                    <strong :style="$vuetify.theme.dark ? '' : 'color: #000000de;'">
                                        {{ getPercent('companiesUtils', 'privateYellow', 'privateLength') }}%
                                    </strong>
                                </v-progress-circular>
                            </v-col>
                            <v-col cols="12" md="4" align="center">
                                <p>Low ({{ companiesUtils.privateGreen }})</p>
                                <v-progress-circular
                                    color="#1ac38d"
                                    :width="smallProgress.width"
                                    :rotate="smallProgress.rotate"
                                    :size="smallProgress.size"
                                    :value="getPercent('companiesUtils', 'privateGreen', 'privateLength')">
                                    <strong>{{ getPercent('companiesUtils', 'privateGreen', 'privateLength') }}%</strong>
                                </v-progress-circular>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>

                <p class="pt-2 mb-0 text-body-2 text--secondary">
                    <v-icon small>mdi-clock-outline</v-icon> Last synced on
                    <strong>
                        {{ new Date(Number(companiesUtils.timestamp.seconds) * 1000).toLocaleString('en-UK') }}
                    </strong>
                </p>
            </v-tab-item>

            <v-tab-item v-else>
                <v-row class="mt-2">
                    <v-col cols="12" md="4">
                        <p class="ma-0">Please sync companies utils in settings.</p>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- Users Tab -->

            <v-tab-item v-if="loadingUsers">
                <v-row class="py-10">
                    <v-col cols="12" class="d-flex justify-center align-center">
                        <v-progress-circular
                            indeterminate
                            color="primary"
                            size="60"
                            width="5">
                        </v-progress-circular>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item v-else-if="syncNeededUsers">
                <h3 class="ml-4 mt-4">People using this platform</h3>
                <v-row class="mx-2 my-2">
                    <v-col cols="12" sm="6" md="3" v-for="user of getUsersPublic" :key="user.displayName">
                        <v-card class="fill-height" elevation="0" outlined>
                            <v-card-text align="center" align-self="center">
                                <div class="text-right">
                                    <v-icon right>{{ user.display ? 'mdi-eye' : 'mdi-eye-off' }}</v-icon>
                                </div>
                                <v-img
                                    :lazy-src="user.photoURL"
                                    :src="user.photoURL"
                                    height="80"
                                    width="80"
                                    class="rounded-circle">
                                    <template v-slot:placeholder>
                                        <v-avatar class="fill-height" color="primary" width="80" height="80" rounded>
                                            <v-icon color="white" large>mdi-account</v-icon>
                                        </v-avatar>
                                    </template>
                                </v-img>
                                <v-card-title class="justify-center">{{ user.displayName }}</v-card-title>
                                <v-card-subtitle class="justify-center">{{ user.title }}</v-card-subtitle>
                                <p v-if="user.bio">{{ user.bio.length > 120 ? `${user.bio.slice(0, 126)}...` : user.bio }}</p>
                                <v-btn icon color="blue" :href="user.linkedin" v-if="user.linkedin">
                                    <v-icon>mdi-linkedin</v-icon>
                                </v-btn>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-tab-item>

            <v-tab-item v-else>
                <v-row class="mt-2">
                    <v-col cols="12" md="4">
                        <p class="ma-0">Please sync users in settings.</p>
                    </v-col>
                </v-row>
            </v-tab-item>

        </v-tabs>

    </v-card>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
    name: 'Dashboard',
    data() {
        return {
            progress: {
                rotate: 270,
                size: 100,
                width: 10
            },
            smallProgress: {
                rotate: 270,
                size: 80,
                width: 8
            }
        }
    },

    created() {
        this.loadUsersPublic();
    },

    computed: {
        ...mapGetters({
            companiesUtils: 'dashboard/companiesUtils',
            getUsersPublic: 'usersPublic/getUsersPublic'
        }),
        mdAndUp() {
            return this.$vuetify.breakpoint.mdAndUp;
        },
        loadingCompanies() {
            return !this.companiesUtils;
        },
        loadingUsers() {
            return !this.getUsersPublic;
        },
        syncNeededCompanies() {
            for (const prop in this.companiesUtils) {
                if (this.companiesUtils[prop] === undefined || this.companiesUtils[prop] === null) {
                    return false;
                }
            }
            return true;
        },
        syncNeededUsers() {
            for (const prop in this.getUsersPublic) {
                if (this.getUsersPublic[prop] === undefined || this.getUsersPublic[prop] === null) {
                    return false;
                }
            }
            return true;
        }
    },

    methods: {
        ...mapActions({
            loadUsersPublic: 'usersPublic/loadUsersPublic'
        }),
        getPercent(utils, propX, propTotal) {
            const result = Math.round(this[utils][propX] * 100 / this[utils][propTotal]);
            return isNaN(result) ? 0 : result;
        }
    }
}
</script>
